
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AdminSettingsTabs from '@/components/admin/AdminSettingsTabs';
import { useAdminSettings } from '@/hooks/useAdminSettings';
import AdminLayout from '@/components/admin/AdminLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeft, FormInput } from 'lucide-react';

const AdminSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isLoading,
    activeTab,
    setActiveTab,
    user,
    handleLogout,
    handleSaveSettings
  } = useAdminSettings();

  // Set active tab based on query parameter
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab');
    if (tab && ['email', 'referralUrls', 'referralTemplates', 'notifications', 'redemption', 'integrations', 'autoUserEmail', 'ecommerce'].includes(tab)) {
      setActiveTab(tab);
    }
  }, [location.search, setActiveTab]);

  const handleManageSignupForm = () => {
    navigate('/admin/signup-form');
  };

  return (
    <AdminLayout
      isLoading={isLoading}
      userRole={user?.role}
      onLogout={handleLogout}
      activeTab="settings"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/admin/dashboard')}
            className="mb-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Button>
          
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">Admin Settings</h1>
            {user?.role && (
              <span className="ml-3 px-3 py-1 text-xs font-semibold text-white rounded-full bg-yellow-500">
                {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
              </span>
            )}
          </div>
          <p className="text-gray-600">Configure your referral program settings</p>
        </div>
        
        <div className="mb-6">
          <Button
            variant="outline"
            onClick={handleManageSignupForm}
            className="flex items-center"
          >
            <FormInput className="h-4 w-4 mr-2" />
            Manage Signup Form
          </Button>
        </div>
        
        <AdminSettingsTabs 
          activeTab={activeTab}
          onTabChange={setActiveTab}
          configs={{
            email: null,
            referralUrls: [],
            referralTemplates: [],
          }}
          onConfigSaved={async () => {
            await handleSaveSettings('settings');
          }}
        />
      </div>
    </AdminLayout>
  );
};

export default AdminSettings;
